import { render, staticRenderFns } from "./Compra.vue?vue&type=template&id=20f3c99c&scoped=true&"
import script from "./Compra.vue?vue&type=script&lang=js&"
export * from "./Compra.vue?vue&type=script&lang=js&"
import style0 from "./Compra.vue?vue&type=style&index=0&id=20f3c99c&prod&lang=scss&scoped=true&"
import style1 from "./Compra.vue?vue&type=style&index=1&id=20f3c99c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f3c99c",
  null
  
)

export default component.exports